import AuthService from '../services/AuthService'
import UserService from '../services/UserService'
import GrupoPanelService from '../services/GrupoPanelService'

// Tema, dealer y logo guardados según el usuario (el Administrador de Grupo no tiene dealer)
function storeDealerBranding (user, roles) {
  const dealer = user && user.dealer
  if (roles.includes('admin') || !dealer) {
    localStorage.setItem('theme', 'default')
    localStorage.removeItem('dealer')
    localStorage.removeItem('logo')
    return
  }
  localStorage.setItem('theme', dealer.theme)
  localStorage.setItem('dealer', dealer.name)
  if (dealer.imageUrl && Object.keys(dealer.imageUrl).length > 0) {
    localStorage.setItem('logo', JSON.stringify({ id: dealer.imageUrl.id, url: dealer.imageUrl.url }))
  } else {
    localStorage.removeItem('logo')
  }
}

const initialState = {
  first_name: '',
  last_name: '',
  email: ''
}

const state = () => ({
  token: null,
  user: initialState,
  roles: (() => {
    try {
      const stored = localStorage.getItem('user.roles')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : []
    } catch (e) {
      return []
    }
  })(),
  permissions: (() => {
    try {
      const stored = localStorage.getItem('user.permissions')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : []
    } catch (e) {
      return []
    }
  })(),
  partnerPermissions: (() => {
    try {
      const stored = localStorage.getItem('user.partner_permissions')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : {}
    } catch (e) {
      return {}
    }
  })(),
  isPartner: (() => {
    try {
      const stored = localStorage.getItem('user.is_partner')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : false
    } catch (e) {
      return false
    }
  })(),
  inSwitchedSession: localStorage.getItem('switch_session_mode') === 'true'
})

const mutations = {
  AUTH_SUCCESS: (state, { token, user, roles, permissions, partnerPermissions, isPartner }) => {
    state.user = user
    state.roles = roles
    state.permissions = permissions || []
    state.partnerPermissions = partnerPermissions || {}
    state.isPartner = isPartner
    localStorage.setItem('user.roles', JSON.stringify(roles))
    localStorage.setItem('user.permissions', JSON.stringify(permissions || []))
    localStorage.setItem('user.partner_permissions', JSON.stringify(partnerPermissions || {}))
    localStorage.setItem('user.is_partner', JSON.stringify(isPartner))
    state.token = token
  },

  LOGOUT: (state) => {
    state.token = null
    state.user = initialState
    state.roles = []
    state.permissions = []
    state.partnerPermissions = {}
    localStorage.removeItem('user.roles')
    localStorage.removeItem('user.permissions')
    localStorage.removeItem('user.is_partner')
    localStorage.removeItem('username')
    localStorage.removeItem('theme')
    localStorage.removeItem('logo')
    localStorage.removeItem('dealer')
    localStorage.removeItem('switch_session_mode')
    localStorage.removeItem('grupo_session')
    localStorage.removeItem('previousNotificationIds')
    localStorage.removeItem('user.partner_permissions')
    localStorage.removeItem('chatbot_data')

    // Clear sessionStorage
    try {
      sessionStorage.clear()
    } catch (e) {}

    // Clear all cookies
    try {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
      // Delete cookie for current path
      document.cookie = name + '=; Max-Age=0; path=/;'
      // Attempt to delete cookie for hostname
      try {
        document.cookie = name + '=; Max-Age=0; path=/; domain=' + window.location.hostname + ';'
      } catch (err) {}
      }
    } catch (e) {}

    // Clear Cache Storage (Service Worker / Cache API)
    if (typeof caches !== 'undefined') {
      caches.keys().then(function(names) {
      for (let name of names) {
        caches.delete(name)
      }
      }).catch(() => {})
    }
  },

  SET_SWITCH_SESSION_MODE: (state, isEnabled) => {
    state.inSwitchedSession = isEnabled
    if (isEnabled) {
      localStorage.setItem('switch_session_mode', 'true')
    } else {
      localStorage.removeItem('switch_session_mode')
    }
  },

  RETURN_TO_ORIGINAL_SESSION: (state, { token, user, roles, permissions }) => {
    state.token = token
    state.user = user
    state.roles = roles
    state.permissions = permissions || []
    localStorage.setItem('user.roles', JSON.stringify(roles))
    localStorage.setItem('user.permissions', JSON.stringify(permissions || []))
    state.inSwitchedSession = false
  },

  UPDATE_SESSION_ROLES: (state, { roles, permissions }) => {
    state.roles = roles
    state.permissions = permissions || []
    localStorage.setItem('user.roles', JSON.stringify(roles))
    localStorage.setItem('user.permissions', JSON.stringify(permissions || []))
  },

  // Actualiza solo el token (para el flujo de switch session, sin pisar isPartner/partnerPermissions en localStorage)
  SET_TOKEN_ONLY: (state, token) => {
    state.token = token
  }
}

const actions = {
  LOGIN: async ({ commit }, credentials) => {
    try {
      let response = await AuthService.login(credentials)
      if (response.status === 200 && response.data) {
        let token = response.data.data.access_token
        let user = response.data.data
        let roles = response.data.data.roles
        let permissions = response.data.data.permissions || []
        let partnerPermissions = response.data.data.partner_permissions || {}
        let isPartner = response.data.data.partner_group_member || false
        commit('AUTH_SUCCESS', { token, user, roles, permissions, partnerPermissions, isPartner })
        let name = await UserService.getMe()
        if (name.data.data.dealer && name.data.data.dealer.imageUrl && Object.keys(name.data.data.dealer.imageUrl).length > 0) {
          localStorage.setItem('logo', JSON.stringify({ id: name.data.data.dealer.imageUrl.id, url: name.data.data.dealer.imageUrl.url }))
        }
        localStorage.setItem('username', JSON.stringify({ email: name.data.data.email, name: name.data.data.name }))
        user = name.data.data

        // Parse comodato_config if it's a JSON string
        if (user.dealer && user.dealer.comodato_config && typeof user.dealer.comodato_config === 'string') {
          try {
            user.dealer.comodato_config = JSON.parse(user.dealer.comodato_config)
            console.log('[AuthStore] comodato_config parseado:', user.dealer.comodato_config)
          } catch (e) {
            console.error('[AuthStore] Error parseando comodato_config:', e)
          }
        }

        commit('AUTH_SUCCESS', { token, user, roles, permissions, partnerPermissions, isPartner })
        // Obtener el tema del dealer
        storeDealerBranding(user, roles)
      }
      return null
    } catch (error) {
      console.error('Error during login:', error)
      return { data: error.response ? error.response.data : error.message, status: error.response ? error.response.status : 500 }
    }
  },

  SIGNUP: async ({ commit }, userDetails) => {
    try {
      let { data, status } = await AuthService.signup(userDetails)
      if (status === 200) {
        commit('ADD_USER', data)
        window.app.$toast.success('El usuario ha sido registrado satisfactoriamente')
      }
      return null
    } catch (error) {
      return { data: error.response.data, status: error.response.status }
    }
  },

  LOGOUT: async ({ commit }) => {
    commit('LOGOUT')
  },
  RETURN_TO_ORIGINAL_SESSION: async ({ commit }) => {
    try {
      const originalSession = JSON.parse(localStorage.getItem('original_session'))

      if (originalSession) {
        const { token, roles, permissions } = originalSession

        // Usar ya el token original: si no, getMe() devolvería al usuario del dealer
        commit('SET_TOKEN_ONLY', token)

        // Recuperar información del usuario original
        let response = await UserService.getMe()
        let user = response.data.data
        let partnerPermissions = user.partner_permissions || {}
        let isPartner = user.partner_group_member || false

        // Actualizar el estado con los datos originales
        commit('AUTH_SUCCESS', { token, user, roles: JSON.parse(roles), permissions: JSON.parse(permissions || '[]'), partnerPermissions, isPartner })

        // Limpiar datos de sesión cambiada
        localStorage.removeItem('original_session')
        localStorage.removeItem('switch_session_mode')

        return true
      }
      return false
    } catch (error) {
      console.error('Error al volver a la sesión original:', error)
      return false
    }
  },

  // Nueva acción para recargar los datos del usuario actual
  RELOAD_USER_DATA: async ({ commit, state }) => {
    try {
      if (!state.token) {
        return false
      }

      let response = await UserService.getMe()
      let user = response.data.data
      let token = state.token
      let roles = state.roles
      let permissions = state.permissions
      let partnerPermissions = user.partner_permissions || state.partnerPermissions || {}
      let isPartner = user.partner_group_member !== undefined ? user.partner_group_member : state.isPartner

      // Parse comodato_config if it's a JSON string
      if (user.dealer && user.dealer.comodato_config && typeof user.dealer.comodato_config === 'string') {
        try {
          user.dealer.comodato_config = JSON.parse(user.dealer.comodato_config)
          console.log('[AuthStore - RELOAD_USER_DATA] comodato_config parseado:', user.dealer.comodato_config)
        } catch (e) {
          console.error('[AuthStore - RELOAD_USER_DATA] Error parseando comodato_config:', e)
        }
      }

      // Actualizar el estado con los datos completos del usuario
      commit('AUTH_SUCCESS', { token, user, roles, permissions, partnerPermissions, isPartner })

      // Actualizar información en localStorage
      if (user.dealer && user.dealer.imageUrl && Object.keys(user.dealer.imageUrl).length > 0) {
        localStorage.setItem('logo', JSON.stringify({ id: user.dealer.imageUrl.id, url: user.dealer.imageUrl.url }))
      }
      localStorage.setItem('username', JSON.stringify({ email: user.email, name: user.name }))

      // Actualizar tema del dealer
      storeDealerBranding(user, roles)

      return true
    } catch (error) {
      console.error('Error al recargar datos del usuario:', error)
      return false
    }
  },

  // Entorno Grupo 5.12: el Administrador de Grupo entra en un dealer de su grupo
  // y opera como su Manager. Se guarda la sesión de Grupo para poder volver.
  ENTER_DEALER: async ({ commit, state }, dealerId) => {
    const response = await GrupoPanelService.enterDealer(dealerId)
    const data = response.data.data

    localStorage.setItem('grupo_session', JSON.stringify({
      token: state.token,
      roles: state.roles,
      permissions: state.permissions
    }))

    const grupoSession = { token: state.token, user: state.user, roles: state.roles, permissions: state.permissions }
    commit('AUTH_SUCCESS', { token: data.access_token, user: state.user, roles: data.roles, permissions: data.permissions, partnerPermissions: {}, isPartner: false })
    try {
      const me = await UserService.getMe()
      const user = me.data.data
      commit('AUTH_SUCCESS', { token: data.access_token, user, roles: data.roles, permissions: data.permissions, partnerPermissions: {}, isPartner: false })
      storeDealerBranding(user, data.roles)
    } catch (error) {
      // No se pudo cargar el dealer: se vuelve a la sesión de Grupo
      commit('AUTH_SUCCESS', { ...grupoSession, partnerPermissions: {}, isPartner: false })
      localStorage.removeItem('grupo_session')
      throw error
    }
    return data.acting_dealer
  },

  // Super Admin: entra en un grupo como gestor (opera como su Administrador de Grupo, pero sigue
  // siendo el mismo usuario, así sus acciones quedan a su nombre). Se guarda su sesión para volver.
  ENTER_GRUPO: async ({ commit, state }, grupoId) => {
    const response = await AuthService.enterGrupo(grupoId)
    const data = response.data.data

    localStorage.setItem('admin_session', JSON.stringify({
      token: state.token,
      roles: state.roles,
      permissions: state.permissions
    }))

    const adminSession = { token: state.token, user: state.user, roles: state.roles, permissions: state.permissions }
    commit('AUTH_SUCCESS', { token: data.access_token, user: state.user, roles: data.roles, permissions: data.permissions, partnerPermissions: {}, isPartner: false })
    try {
      const me = await UserService.getMe()
      commit('AUTH_SUCCESS', { token: data.access_token, user: me.data.data, roles: data.roles, permissions: data.permissions, partnerPermissions: {}, isPartner: false })
    } catch (error) {
      // No se pudo cargar el grupo: se vuelve a la sesión de Super Admin
      commit('AUTH_SUCCESS', { ...adminSession, partnerPermissions: {}, isPartner: false })
      localStorage.removeItem('admin_session')
      throw error
    }
    return data.acting_grupo
  },

  // Vuelve a la sesión de Super Admin
  EXIT_GRUPO: async ({ commit }) => {
    let token, roles, permissions
    try {
      const response = await AuthService.exitGrupo()
      token = response.data.data.access_token
      roles = response.data.data.roles
      permissions = response.data.data.permissions
    } catch (error) {
      // Si el token de grupo ya no vale, se recupera la sesión de Super Admin guardada
      const saved = JSON.parse(localStorage.getItem('admin_session') || 'null')
      if (!saved) {
        throw error
      }
      token = saved.token
      roles = saved.roles
      permissions = saved.permissions
    }

    commit('AUTH_SUCCESS', { token, user: {}, roles, permissions, partnerPermissions: {}, isPartner: false })
    const me = await UserService.getMe()
    commit('AUTH_SUCCESS', { token, user: me.data.data, roles, permissions, partnerPermissions: {}, isPartner: false })
    localStorage.removeItem('admin_session')
  },

  // Vuelve al panel de Grupo
  EXIT_DEALER: async ({ commit }) => {
    let token, roles, permissions
    try {
      const response = await AuthService.exitDealer()
      token = response.data.data.access_token
      roles = response.data.data.roles
      permissions = response.data.data.permissions
    } catch (error) {
      // Si el token de dealer ya no vale, se recupera la sesión de Grupo guardada
      const saved = JSON.parse(localStorage.getItem('grupo_session') || 'null')
      if (!saved) {
        throw error
      }
      token = saved.token
      roles = saved.roles
      permissions = saved.permissions
    }

    commit('AUTH_SUCCESS', { token, user: {}, roles, permissions, partnerPermissions: {}, isPartner: false })
    const me = await UserService.getMe()
    const user = me.data.data
    commit('AUTH_SUCCESS', { token, user, roles, permissions, partnerPermissions: {}, isPartner: false })
    storeDealerBranding(user, roles)
    localStorage.removeItem('grupo_session')
    return true
  },

  // Alias para RELOAD_USER_DATA para compatibilidad
  LOAD_CURRENT_USER: async ({ dispatch }) => {
    return dispatch('RELOAD_USER_DATA')
  },

  // Acción para cambiar de sesión
  SWITCH_SESSION: async ({ commit, state }, { token, user, roles, permissions, partnerPermissions, isPartner }) => {
    try {
      // Guardar la sesión original ANTES de cambiar (esto debe hacerse fuera de esta acción)
      // Esta acción asume que la sesión original ya fue guardada

      // Actualizar con la nueva sesión
      commit('AUTH_SUCCESS', { token, user, roles, permissions: permissions || [], partnerPermissions: partnerPermissions || {}, isPartner: isPartner || false })
      commit('SET_SWITCH_SESSION_MODE', true)

      return true
    } catch (error) {
      console.error('Error al cambiar de sesión:', error)
      return false
    }
  }
}

const getters = {
  HAS_ROLE: (state) => (roles) => {
    const userRoles = state.roles

    if (!userRoles || userRoles.length === 0) {
      return false
    }

    if (userRoles.includes('Administrador')) {
      return true
    }

    return !!roles.some(el => userRoles.includes(el))
  },
  IS_PARTNER: state => {
    return state.isPartner
  },

  HAS_PERMISSION: (state) => (permission) => {
    const userPermissions = state.permissions

    if (!userPermissions || userPermissions.length === 0) {
      return false
    }

    // Si el usuario tiene rol de Administrador, tiene todos los permisos
    if (state.roles && (state.roles.includes('admin') || state.roles.includes('Administrador'))) {
      return true
    }

    // Si el usuario tiene rol de Manager, tiene todos los permisos sobre su dealer
    if (state.roles && state.roles.includes('manager')) {
      const managerPermissions = [
        'manage_users',
        'agregar_usuario_normal',
        'actualizar_usuario',
        'eliminar_usuario',
        'crear_vehiculo',
        'editar_vehiculo',
        'eliminar_vehiculo',
        'crear_conductor',
        'editar_conductor',
        'eliminar_conductor',
        'crear_movimiento',
        'editar_movimiento',
        'eliminar_movimiento',
        'crear_grua',
        'editar_grua',
        'eliminar_grua',
        'crear_ubicacion',
        'editar_ubicacion',
        'eliminar_ubicacion',
        'manage_dealer',
        'manage_equipamiento_config',
        'manage_notifications',
        'descargar_comodato',
        'importacion_masiva_excel'
      ]

      // Si el permiso solicitado está en la lista de permisos de manager, concederlo
      if (managerPermissions.includes(permission)) {
        return true
      }
    }

    // Para otros usuarios, verificar si tienen el permiso específico
    return userPermissions.includes(permission)
  },

  CURRENT_USER_ROLES: state => {
    return state.roles || []
  },

  CURRENT_USER_PERMISSIONS: state => {
    return state.permissions || []
  },

  CURRENT_USER: state => {
    return state.user
  },

  LOGGED_IN: state => {
    return state.token !== null
  },

  BEARER_TOKEN: state => {
    return state.token
  },

  IN_SWITCHED_SESSION: state => {
    return state.inSwitchedSession
  },

  // Administrador de Grupo en el panel de Grupo (no dentro de un dealer)
  IS_GROUP_ADMIN: state => {
    return (state.roles || []).includes('group_admin')
  },

  // Grupo en el que ha entrado el Super Admin como gestor (null si no)
  ACTING_GRUPO_ID: state => {
    return state.user && state.user.acting_grupo_id ? state.user.acting_grupo_id : null
  },

  // Dealer en el que ha entrado el Administrador de Grupo (null si no)
  ACTING_DEALER_ID: state => {
    return state.user && state.user.acting_dealer_id ? state.user.acting_dealer_id : null
  },

  /**
   * Getter para verificar si el dealer del usuario tiene un tipo de vehículo específico activado
   * Uso: this.$store.getters.DEALER_HAS_TYPE('vn')
   * @param {string} type - El tipo de vehículo a verificar: 'vn', 'vo', o 'taller'
   * @returns {boolean} - true si el dealer tiene ese tipo activado, false en caso contrario
   */
  DEALER_HAS_TYPE: (state) => (type) => {
    // Verificar que el usuario existe y tiene dealer
    if (!state.user || !state.user.dealer) {
      return false
    }

    const dealer = state.user.dealer

    // Verificar el tipo específico solicitado
    switch (type.toLowerCase()) {
      case 'vn':
        return !!dealer.vn
      case 'vo':
        return !!dealer.vo
      case 'taller':
        return !!dealer.taller
      default:
        return false
    }
  },

  /**
   * Getter para obtener la cantidad de tipos de vehículos activos del dealer
   * Útil para determinar qué plan de suscripción mostrar
   * @returns {number} - Cantidad de tipos activos (0-3)
   */
  DEALER_ACTIVE_TYPES_COUNT: (state) => {
    if (!state.user || !state.user.dealer) {
      return 0
    }

    const dealer = state.user.dealer
    let count = 0

    if (dealer.vn) count++
    if (dealer.vo) count++
    if (dealer.taller) count++

    return count
  },
  // ¿Tiene el user algún permiso sobre algún dealer partner?
HAS_ANY_PARTNER_PERMISSION: (state) => {
  return Object.keys(state.partnerPermissions).length > 0
},

// ¿Tiene el user un permiso específico sobre un dealer partner concreto?
// Uso: this.$store.getters.HAS_PARTNER_PERMISSION({ dealerId: 6, permission: 'crear_vehiculo' })
HAS_PARTNER_PERMISSION: (state) => ({ dealerId, permission }) => {
  if (!state.partnerPermissions || !dealerId) return false
  const dealerPerms = state.partnerPermissions[dealerId] || []
  return dealerPerms.includes(permission)
},

// Todos los dealer IDs sobre los que el user tiene permisos de partner
PARTNER_DEALER_IDS: (state) => {
  return Object.keys(state.partnerPermissions).map(Number)
},

// Todos los permisos del user sobre un dealer partner específico
GET_PARTNER_PERMISSIONS_FOR_DEALER: (state) => (dealerId) => {
  return state.partnerPermissions[dealerId] || []
},

// Getter combinado: tiene el permiso en su dealer propio O en algún dealer partner
HAS_PERMISSION_ANYWHERE: (state, getters) => (permission) => {
  // En su propio dealer
  if (getters.HAS_PERMISSION(permission)) return true

  // En algún dealer partner
  return Object.values(state.partnerPermissions).some(perms =>
    perms.includes(permission)
  )
}
}

export default {
  state,
  mutations,
  actions,
  getters
}
